import { BarcodeScanner } from 'dynamsoft-javascript-barcode';

BarcodeScanner.license =
  'DLS2eyJoYW5kc2hha2VDb2RlIjoiMzkyMDc5LTg0OGFjMmM2IiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjozOTIwNzksInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi00MjgzNTEzMX0=';
// BarcodeScanner.engineResourcePath =
//   '/node_modules/dynamsoft-javascript-barcode/dist/dbr.js';
BarcodeScanner.engineResourcePath =
  'https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.6.20/dist/';
// Dynamsoft.BarcodeReader.productKeys = '848ac2c6';
// Dynamsoft.BarcodeReader._bUseFullFeature = true; // Control of loading min wasm or full wasm.
export default BarcodeScanner;
